import React from "react";

const RewardBanner: React.FC = () => (
  <div className="reward-buy-container">
    <div className="reward-info">
      🎁 You have an existing reward! Use it now.
    </div>
    <button className="buy-now-btn">
      Buy Now
    </button>
  </div>
);

export default RewardBanner;
